import React from "react";
import Header from "../../Shared/Header/Header";
import Footer from "../../Shared/Footer/Footer";
import About from "../About/About";
import Banner from "../Banner/Banner";
import Contact from "../Contact/Contact";
import OpenSource from "../OpenSource/OpenSource";
import ProfessionalArc from "../ProfessionalArc/ProfessionalArc";
import TopBlogs from "../TopBlogs/TopBlogs/TopBlogs";
import TopProjects from "../TopProjects/TopProjects/TopProjects";

const HomeComponents = () => {
  return (
    <div className="portfolio-home">
      <Header />
      <Banner />
      <ProfessionalArc />
      <OpenSource />
      <TopProjects />
      <TopBlogs />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomeComponents;
